"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GeodesPreview_exports = {};
__export(GeodesPreview_exports, {
  default: () => GeodesPreview_default
});
module.exports = __toCommonJS(GeodesPreview_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.8125 6.42188V16.5195C11.3724 15.8555 12.0039 15.2695 12.707 14.7617C13.4102 14.2539 14.1589 13.8372 14.9531 13.5117L15.168 13.4336V3.57031L14.8164 3.70703C14.0612 4.00651 13.3451 4.39062 12.668 4.85938C11.9909 5.3151 11.3724 5.83594 10.8125 6.42188ZM16.0078 14.7031L15.3633 14.8789C14.7383 15.0221 14.1458 15.2565 13.5859 15.582C13.0391 15.8945 12.5378 16.2721 12.082 16.7148C12.9023 16.4674 13.7292 16.2786 14.5625 16.1484C15.3958 16.0052 16.2357 15.9206 17.082 15.8945L18.0391 15.875V5.58203H16.0078V14.7031ZM9.75781 16.9297V6.65625C9.25 6.48698 8.74219 6.34375 8.23438 6.22656C7.71354 6.10938 7.19271 6.01172 6.67188 5.93359C6.15104 5.85547 5.63021 5.79688 5.10938 5.75781C4.57552 5.70573 4.04818 5.67969 3.52734 5.67969H2.96094V15.8555H3.48828C4.02214 15.8555 4.55599 15.8815 5.08984 15.9336C5.61068 15.9727 6.13151 16.0378 6.65234 16.1289C7.1862 16.2201 7.71354 16.3307 8.23438 16.4609C8.74219 16.6042 9.25 16.7604 9.75781 16.9297Z",
      fill: "currentColor"
    }
  )
);
const SvgGeodesPreview = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var GeodesPreview_default = SvgGeodesPreview;
